import React, { useState } from "react";
import "./header.css";
import agentRAILogo from "../../images/agent-rai-logo.svg";
import { useNavigate } from "react-router-dom";

export default function Header({ scrollToSection }) {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const navigate = useNavigate();
  const handleHamburgerClick = () => {
    setIsMenuActive(!isMenuActive);
  };

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setActiveTab("");
  };

  const handleTabClick = (section) => {
    setActiveTab(section);
    scrollToSection(section);
    setIsMenuActive(false);
  };

  return (
    <div className="navbar">
      <div className="container">
        <div className="nav-items-wrapper">
          <div className="agent-rai-logo">
            <img
              src={agentRAILogo}
              alt="agent-rai-logo"
              onClick={handleLogoClick}
            />
          </div>
          <div className="menu-items">
            <ul>
              <li onClick={() => navigate("/agenttrust")}>Agent Trust</li>
              <li
                className={activeTab === "solution" ? "active" : ""}
                onClick={() => handleTabClick("solution")}
              >
                Solutions
              </li>
              <li
                className={activeTab === "feature" ? "active" : ""}
                onClick={() => handleTabClick("feature")}
              >
                Features
              </li>
              <li
                className={activeTab === "useCases" ? "active" : ""}
                onClick={() => handleTabClick("useCases")}
              >
                Use Cases
              </li>
              <li
                className={activeTab === "faq" ? "active" : ""}
                onClick={() => handleTabClick("faq")}
              >
                FAQ
              </li>
            </ul>
          </div>
          <div className="hamburger-menu" onClick={handleHamburgerClick}>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div
            className={`mobile-menu ${
              isMenuActive ? "mobile-menu-active" : ""
            }`}
          >
            <ul>
              <li onClick={() => navigate("/agenttrust")}>Agent Trust</li>
              <li
                className={activeTab === "solution" ? "active" : ""}
                onClick={() => handleTabClick("solution")}
              >
                Solutions
              </li>
              <li
                className={activeTab === "feature" ? "active" : ""}
                onClick={() => handleTabClick("feature")}
              >
                Features
              </li>
              <li
                className={activeTab === "useCases" ? "active" : ""}
                onClick={() => handleTabClick("useCases")}
              >
                Use Cases
              </li>
              <li
                className={activeTab === "faq" ? "active" : ""}
                onClick={() => handleTabClick("faq")}
              >
                FAQ
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
